import {isMobile} from "react-device-detect";
import MobileServiceGuideDetailsItem from "./MobileServiceGuideDetailsItem";
import DesktopServiceGuideDetailsItem from "./DesktopServiceGuideDetailsItem";

export default isMobile ? MobileServiceGuideDetailsItem : DesktopServiceGuideDetailsItem;